import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ScreenHeader, Surface, Button, Avatar, Divider, Icon, FeedbackMsg } from '../components/ui';

const API_URL = process.env.REACT_APP_API_URL;

export default function AprovacaoAlunos() {
  const [alunos, setAlunos] = useState([]);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(true);

  function carregar() {
    setLoading(true);
    axios.get(`${API_URL}/alunos_pendentes`, { withCredentials: true })
      .then(r => setAlunos(r.data))
      .catch(() => setAlunos([]))
      .finally(() => setLoading(false));
  }

  useEffect(() => { carregar(); }, []);

  function aprovar(id) {
    axios.post(`${API_URL}/aprovar/${id}`, {}, { withCredentials: true })
      .then(() => {
        setMsg('Aluno aprovado!');
        setAlunos(prev => prev.filter(a => a.id !== id));
        setTimeout(() => setMsg(''), 3000);
      })
      .catch(() => setMsg('Erro ao aprovar.'));
  }

  return (
    <div className="mema-screen" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--gap-3)', paddingBottom: 90 }}>
      <ScreenHeader title="Aprovar alunos"/>

      <div style={{ padding: '0 var(--gap-3)' }}>
        {msg && <div style={{ marginBottom: 'var(--gap-2)' }}><FeedbackMsg msg={msg}/></div>}

        {loading ? (
          <div style={{ textAlign: 'center', padding: 'var(--gap-4)', color: 'var(--text-tertiary)', fontSize: 13 }}>
            Carregando…
          </div>
        ) : alunos.length === 0 ? (
          <Surface padded style={{ textAlign: 'center', padding: 'var(--gap-4)' }}>
            <Icon name="user-check" size={28} style={{ margin: '0 auto 8px', display: 'block', opacity: 0.35, color: 'var(--text-tertiary)' }}/>
            <div style={{ fontSize: 14, fontWeight: 540, color: 'var(--text-primary)' }}>Nenhum aluno pendente</div>
            <div style={{ fontSize: 13, color: 'var(--text-tertiary)', marginTop: 4 }}>Todos os cadastros foram revisados.</div>
          </Surface>
        ) : (
          <Surface>
            {alunos.map((a, i) => (
              <React.Fragment key={a.id}>
                {i > 0 && <Divider/>}
                <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--gap-2)', padding: 'var(--pad-card)' }}>
                  <Avatar name={a.nome} size={40}/>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 540, color: 'var(--text-primary)',
                      whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{a.nome}</div>
                    <div style={{ fontSize: 12, color: 'var(--text-tertiary)',
                      whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{a.email}</div>
                    {a.telefone && <div style={{ fontSize: 11.5, color: 'var(--text-tertiary)' }}>{a.telefone}</div>}
                  </div>
                  <Button size="sm" variant="soft" icon="check" onClick={() => aprovar(a.id)}>Aprovar</Button>
                </div>
              </React.Fragment>
            ))}
          </Surface>
        )}
      </div>
    </div>
  );
}
